<template>
    <lv-base-column
            ref="column" v-bind="columnBinding">
        <template slot-scope="{row,rowIndex,col,colIndex,editRow,fixedRow,}">
            <link-table-column-input-number-item
                    :row="row"
                    :edit-row="editRow"
                    :row-index="rowIndex"
                    :col="col"
                    :col-index="colIndex"
                    :fixed-row="fixedRow"
                    v-bind="columnItemBinding"
                    @click="lv_clickItem"

                    :max="max"
                    :min="min"
                    :space="space"
                    :show-icon="showIcon"
                    :is-integer="isInteger"
					:step-strictly="stepStrictly"
					:precision="precision"
                    :align="align"

                    :type="type"
                    :color="color"
                    :size="size"
                    :shape="shape"
                    :dashed="dashed"
                    :long="long"
                    :hide-clear-icon="hideClearIcon"
                    :disabled="disabled"
                    :readonly="readonly"
                    :focus-on-hover="focusOnHover"
                    :required="required"
                    :validate-on-init="validateOnInit"
                    :rules="rules"
                    :regexp="regexp"
					:replacement="replacement"

                    @change="e=>$emit('change',e)"
            />
        </template>
    </lv-base-column>
</template>

<script>
    import {ColumnMixin} from "../mixins";
    import LinkTableColumnInputNumberItem from "./link-table-column-input-number-item";
    import LvBaseColumn from "../../table/lv-base-column";

    export default {
        name: "link-table-column-input-number",
        components: {LinkTableColumnInputNumberItem, LvBaseColumn},
        mixins: [ColumnMixin,],
        props: {
            filterName: {default: 'number'},

            max: {type: Number},                            // 设置计数器最大值
            min: {type: Number},                            // 设置计数器最小值
            space: {type: Number, default: 1},              // 设置计数器每次增加的数量
            showIcon: {type: Boolean, default: true},       // 设置计数器上下icon的显示与隐藏
            align: {type: String},                          // input中文本的对其方式
            isInteger: {type: Boolean},                     // 是否只能输入整数
			stepStrictly: {type: Boolean},                  // 是否只能输入 space 的倍数
			precision: {type: [Number, String]},            // 数值精度

            type: {type: String, default: 'line',},
            color: {type: String, default: 'info',},
            size: {type: String, default: 'default',},
            shape: {type: String, default: 'none',},
            dashed: {type: Boolean,},
            long: {type: Boolean},
            hideClearIcon: {type: Boolean},                             // 是否禁用清除图标
            disabled: {type: Boolean},
            readonly: {type: Boolean},
            focusOnHover: {default: false},
            regexp: {type: RegExp, default: () => /[^\-0-9.]/g},        // 设置input框的校验
			replacement: {type: String, default: ''}                    //  设置替换文本或生成替换文本的函数
        }
    }
</script>

<style scoped>

</style>
